<!-- Modern Customer Profile Bar -->
<div class="py-4">
    <div class="max-w-6xl mx-auto px-4">
        <!-- Customer Profile Section -->
        <div *ngIf="!loading && person?.person" class="mb-4">
            <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                    class="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity">
                    <div class="flex-shrink-0">
                        <img *ngIf="person?.person?.file_selfie"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize(person?.person?.file_selfie?.url)" alt="Avatar del cliente" />
                        <img *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize('../assets/public/images/avatar.png')" alt="Avatar del cliente" />
                        <img *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize('../assets/public/images/avatara-female.png')" alt="Avatar del cliente" />
                    </div>
                    <div class="flex-1">
                        <h2 class="text-xl font-bold text-gray-900 capitalize hover:text-blue-600 transition-colors">
                            {{person?.person?.name}} {{person?.person?.lastName}}
                        </h2>
                        <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
                            <div class="flex items-center gap-1">
                                <i class="fas fa-id-card text-blue-600"></i>
                                <span>{{getIdentity(person)}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="fas fa-phone text-blue-600"></i>
                                <span>{{getContact(person)}}</span>
                            </div>
                            <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                                <i class="fas fa-envelope text-blue-600"></i>
                                <span>{{getEmailContact(person)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mt-md-3 container-fluid">


    <div class="row ">
        <div class=" col-12 col-md-8 offset-md-2">

            <div class="row rmt-2" *ngIf="!loading_person">
                <div class="col-12  col-md-8 offset-md-2">

                    <h5 class="text-secondary mb-4 text-center">

                        <i class="  fas fa-user"></i> Pagos realizados
                    </h5>
                </div>
            </div>

            <ng-container class="mt-4">
                <div class="row rmt-2">
                    <div class="col-12  col-md-10 offset-md-1">


                        <div class="row">

                            <div class="col-12 mt-2  mb-2  col-md-6">
                                <input style="
                                padding: 16px 9px;
                                background: white;
                            " id="demo-external" (onSet)="birthdaySet()" [(ngModel)]="range" mbsc-range
                                    class="form-control" [mbsc-options]="dateSetting3" #externalRange="mobiscroll" />

                            </div>
                        </div>
                        <div class="row">
                            <div class="mt-2 col-12 col-md-6 ">
                                <div class="form-floating ">
                                    <select (change)="setFilter()" [(ngModel)]="filter.type" class="form-select "
                                        id="floatingSelect " aria-label="Floating label select example ">
                                        <option value="all">Todos</option>
                                        <option value="p">Por conciliar</option>
                                        <option value="c">Conciliados</option>
                                        <option value="d">Devoluciones</option>
                                        <option value="a">Anulados / Transacción fallida</option>
                                        <option value="pc">En proceso de validación</option>


                                    </select>
                                    <label for="floatingSelect ">Estatus</label>
                                </div>

                            </div>



                            <div class="mb-4 mt-2 col-12 col-md-6 ">
                                <div class="form-floating ">
                                    <select (change)="setFilter()" [(ngModel)]="filter.account" class="form-select "
                                        id="floatingSelect " aria-label="Floating label select example ">
                                        <option value="">Todos</option>
                                        <option *ngFor="let item of accounts; let i=index" [value]="item?.code">

                                            <span *ngIf="item?.bank">
                                                {{item?.bank?.name}}{{item?.tag ? ' (' + item?.tag + ')' : ''}}
                                                ({{item?.payment_method?.name}})
                                            </span>

                                            <span *ngIf="!item?.bank">
                                                {{item?.payment_method?.name}}{{item?.tag ? ' (' + item?.tag + ')' :
                                                item?.currency?.code ? ' (' + item?.currency?.code + ')' : ''}}
                                            </span>
                                            · {{item | empresaCuentaClase | uppercase}}

                                        </option>

                                    </select>
                                    <label for="floatingSelect ">Forma de pago</label>
                                </div>

                            </div>

                            <div class="mb-4  col-12 col-md-6 " [ngClass]="{'d-none': filter.type != 'p'}">
                                <div class="form-floating ">

                                    <select (change)="setFilter()" [(ngModel)]="filter.sub_status" class="form-select "
                                        id="floatingSelect " aria-label="Floating label select example ">
                                        <option value="ALL">Todos</option>

                                        <option *ngFor="let item of list_payment_sub_status; let i=index"
                                            [value]="item?.code">
                                            {{item?.name}}
                                        </option>

                                    </select>
                                    <label for="floatingSelect ">Sub estatus</label>
                                </div>

                            </div>

                            <div class="mb-4 col-12 col-md-6">
                                <!-- 💎 FILTRO MÚLTIPLE DE PRODUCTOS CON BÚSQUEDA DIRECTA -->
                                <div class="position-relative product-search-input">
                                    <!-- Barra de Búsqueda Principal (estilo form-floating) -->
                                    <div class="form-floating">
                                        <input type="text" class="form-control" id="productSearchPayments"
                                            [(ngModel)]="productSearchTerm" (input)="filterProductsSearch()"
                                            (focus)="openDropdown()" (click)="openDropdown()" [readonly]="!showDropdown"
                                            placeholder="Buscar tipo de producto..." autocomplete="off">
                                        <label for="productSearchPayments">
                                            <i class="fas fa-search me-2"></i>
                                            Buscar tipo de producto
                                        </label>
                                        <!-- Botón limpiar -->
                                        <button type="button"
                                            class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                                            *ngIf="productSearchTerm && (selectedProducts.length > 1 || (selectedProducts.length === 1 && selectedProducts[0] !== 'CREDIT'))"
                                            (click)="clearProductSearch()" style="z-index: 10;">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>

                                    <!-- Dropdown Elegante -->
                                    <div *ngIf="showDropdown"
                                        class="dropdown-menu show position-absolute w-100 mt-2 shadow-lg border-0 filter-dropdown"
                                        style="z-index: 1050;">
                                        <!-- Header con contador -->
                                        <div class="px-3 py-2 bg-light border-bottom">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <small class="text-muted fw-medium">
                                                    <i class="fas fa-list me-1 text-primary"></i>
                                                    {{ filteredProductArray.length }} producto{{
                                                    filteredProductArray.length > 1 ? 's' : '' }} encontrado{{
                                                    filteredProductArray.length > 1 ? 's' : '' }}
                                                </small>
                                                <span class="badge bg-primary">{{ tempSelectedProducts.length }}
                                                    seleccionado{{ tempSelectedProducts.length > 1 ? 's' : '' }}</span>
                                            </div>
                                        </div>

                                        <!-- Lista de Opciones -->
                                        <div class="filter-options" style="max-height: 300px; overflow-y: auto;">

                                            <!-- Loading Skeleton -->
                                            <div *ngIf="filterStates.isLoadingProducts" class="p-3">
                                                <div *ngFor="let item of [1,2,3]"
                                                    class="d-flex align-items-center mb-3">
                                                    <div class="placeholder-glow flex-grow-1">
                                                        <span class="placeholder col-8"></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Opciones Reales -->
                                            <div *ngIf="!filterStates.isLoadingProducts">
                                                <div *ngFor="let item of filteredProductArray; trackBy: trackByProductCode"
                                                    class="filter-option-item px-3 py-3 border-bottom cursor-pointer"
                                                    [class.selected]="isProductSelected(item?.params?.code)"
                                                    (click)="onProductSelectionChange(item?.params?.code, !isProductSelected(item?.params?.code)); $event.stopPropagation()">
                                                    <div class="d-flex align-items-center">
                                                        <!-- Icono -->
                                                        <div class="me-3">
                                                            <i class="fas fa-cube text-primary"></i>
                                                        </div>

                                                        <!-- Texto -->
                                                        <div class="flex-grow-1">
                                                            <div class="fw-medium text-dark">{{ item?.params?.name ||
                                                                item?.params?.code }}</div>
                                                            <small class="text-muted d-block">Código: {{
                                                                item?.params?.code }}</small>
                                                            <small class="text-muted d-block"
                                                                *ngIf="item?.params?.dinamic_code && item?.params?.dinamic_code.length > 0">
                                                                Etiqueta: {{ item?.params?.dinamic_code[0] }}
                                                            </small>
                                                        </div>

                                                        <!-- Check de seleccionado -->
                                                        <div *ngIf="isProductSelected(item?.params?.code)">
                                                            <i class="fas fa-check text-primary fa-lg"></i>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Mensaje cuando no hay resultados -->
                                                <div *ngIf="filteredProductArray.length === 0" class="text-center py-4">
                                                    <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                                    <h6 class="text-muted">No se encontraron productos</h6>
                                                    <p class="text-muted small">Intenta con otro término de búsqueda</p>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Footer con Controles -->
                                        <div class="px-3 py-3 bg-light border-top">
                                            <!-- Info -->
                                            <div class="d-flex align-items-center justify-content-between mb-3">
                                                <small class="text-muted">
                                                    <i class="fas fa-info-circle text-primary me-1"></i>
                                                    {{ tempSelectedProducts.length }} de {{ productArray.length }}
                                                    seleccionados
                                                </small>

                                                <!-- Botón Limpiar -->
                                                <button
                                                    *ngIf="tempSelectedProducts.length > 1 || (tempSelectedProducts.length === 1 && tempSelectedProducts[0] !== 'CREDIT')"
                                                    type="button" class="btn btn-sm btn-outline-secondary"
                                                    (click)="clearAllFilters()">
                                                    <i class="fas fa-times me-1"></i>
                                                    Limpiar
                                                </button>
                                            </div>

                                            <!-- Botones de Acción -->
                                            <div class="d-flex gap-2">
                                                <!-- Cancelar -->
                                                <button type="button" class="btn btn-outline-secondary flex-fill"
                                                    (click)="closeDropdown()"
                                                    [disabled]="filterStates.isApplyingFilter">
                                                    Cancelar
                                                </button>

                                                <!-- Aplicar -->
                                                <button type="button" class="btn btn-primary flex-fill"
                                                    (click)="applyFilters()" [disabled]="filterStates.isApplyingFilter">
                                                    <span *ngIf="!filterStates.isApplyingFilter">
                                                        <i class="fas fa-check me-1"></i>
                                                        Aplicar
                                                    </span>
                                                    <span *ngIf="filterStates.isApplyingFilter">
                                                        <div class="spinner-border spinner-border-sm me-2"
                                                            role="status"></div>
                                                        Aplicando...
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Estado de Error -->
                                    <div *ngIf="filterStates.hasError" class="alert alert-danger mt-3" role="alert">
                                        <div class="d-flex align-items-start">
                                            <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
                                            <div class="flex-grow-1">
                                                <strong>Error en el filtro</strong>
                                                <div class="small">{{ filterStates.errorMessage }}</div>
                                                <button type="button" class="btn btn-sm btn-outline-danger mt-2"
                                                    (click)="retryOperation()">
                                                    <i class="fas fa-redo me-1"></i>
                                                    Reintentar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Overlay de Carga para Pagos -->
                            <div *ngIf="filterStates.isApplyingFilter && !filterStates.isLoadingResults"
                                class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                style="z-index: 1055; background: rgba(255,255,255,0.9);">
                                <div class="text-center">
                                    <div class="spinner-border text-primary mb-3" role="status">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <h5 class="text-primary">Aplicando filtros</h5>
                                    <p class="text-muted mb-0">Obteniendo pagos...</p>
                                </div>
                            </div>

                            <!-- Información del Account Payment Seleccionado -->
                            <div class="col-12 mb-3" *ngIf="selectedAccountPayment">
                                <div class="card border-0 shadow-sm">
                                    <div class="card-header bg-secondary text-white">
                                        <h6 class="mb-0">
                                            <i class="fas fa-credit-card me-2"></i>
                                            Información de la Forma de Pago Seleccionada
                                        </h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-3 col-6">
                                                <div class="text-muted small">Banco</div>
                                                <div class="fw-bold">
                                                    {{selectedAccountPayment?.bank?.name || 'N/A'}}
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-6">
                                                <div class="text-muted small">Método de Pago</div>
                                                <div class="fw-bold">
                                                    <span *ngIf="selectedAccountPayment?.payment_method?.name">
                                                        {{selectedAccountPayment?.payment_method?.name}}{{selectedAccountPayment?.tag
                                                        ? ' (' + selectedAccountPayment?.tag + ')' :
                                                        selectedAccountPayment?.currency?.code ? ' (' +
                                                        selectedAccountPayment?.currency?.code + ')' : ''}}
                                                    </span>
                                                    <span
                                                        *ngIf="!selectedAccountPayment?.payment_method?.name && selectedAccountPayment?.currency?.code">
                                                        {{selectedAccountPayment?.currency?.code}}
                                                    </span>
                                                    <span
                                                        *ngIf="!selectedAccountPayment?.payment_method?.name && !selectedAccountPayment?.currency?.code">
                                                        N/A
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-6">
                                                <div class="text-muted small">Cuenta/Teléfono</div>
                                                <div class="fw-bold">
                                                    <span
                                                        *ngIf="selectedAccountPayment?.number">{{selectedAccountPayment?.number}}</span>
                                                    <span
                                                        *ngIf="selectedAccountPayment?.phone && !selectedAccountPayment?.number">{{selectedAccountPayment?.phone}}</span>
                                                    <span
                                                        *ngIf="!selectedAccountPayment?.number && !selectedAccountPayment?.phone">N/A</span>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-6">
                                                <div class="text-muted small">Etiqueta/Tipo</div>
                                                <div class="fw-bold">
                                                    <span *ngIf="selectedAccountPayment?.tag">
                                                        <span
                                                            class="badge bg-secondary">{{selectedAccountPayment?.tag}}</span>
                                                    </span>
                                                    <span
                                                        *ngIf="!selectedAccountPayment?.tag && selectedAccountPayment?.currency?.name">
                                                        {{selectedAccountPayment?.currency?.name}}
                                                    </span>
                                                    <span
                                                        *ngIf="!selectedAccountPayment?.tag && !selectedAccountPayment?.currency?.name">
                                                        N/A
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- Controles de Ordenamiento -->
                            <div class="col-12 mb-3">
                                <div class="card border-0 sort-controls">
                                    <div class="card-body">
                                        <div class="row align-items-center">
                                            <div class="col-12">
                                                <div class="d-flex align-items-center justify-content-end">
                                                    <div class="btn-group me-3" role="group">
                                                        <button type="button" class="btn btn-sm"
                                                            [class.active]="sortOrder === 'desc'"
                                                            (click)="changeSortOrder('desc')"
                                                            [disabled]="loading_person">
                                                            <i class="fas fa-sort-amount-down me-1"></i>
                                                            Más Reciente
                                                        </button>
                                                        <button type="button" class="btn btn-sm"
                                                            [class.active]="sortOrder === 'asc'"
                                                            (click)="changeSortOrder('asc')"
                                                            [disabled]="loading_person">
                                                            <i class="fas fa-sort-amount-up me-1"></i>
                                                            Más Antiguo
                                                        </button>
                                                    </div>
                                                    <div class="sort-info">
                                                        <i class="fas fa-info-circle"></i>
                                                        {{getSortText()}} {{getSortIcon()}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ng-container>

                            <div class=" w-100  mt-5 mb-2 flex "
                                *ngIf="!loading_person &&  resp_paymentsCredits?.length > 0">

                                <div class="text-end ml-auto">

                                    {{resp_paymentsCredits?.length}}

                                </div>

                            </div>


                            <div class="bg-white mt-4 my-3 p-3 bg-body2  rounded shadow-sm"
                                *ngFor="let item of resp_paymentsCredits">

                                <div class=" mt-2  w-100 text-end "
                                    *ngIf="!item?.payment?.reconciled_payment && item?.payment?.typeTransaction!=='PENDING' ">
                                    <i *ngIf="_auth.hasPermission('finanzas.verificacion_pagos.update')" (click)="setPayment(item)" class="far fa-edit text-primary cursor-pounter"></i>

                                </div>

                                <!-- <div (click)="paymentRollback(item?.payment?.code)"  class=" mt-2  w-100 text-end text-danger "  *ngIf="!(!item?.payment?.reconciled_payment &&  item?.payment?.status)">

                                    <i class="fa-solid fa-caret-left"></i>  Revertir

                                </div> -->



                                <div class="row mt-2 row-k">

                                    <div class="col-12 ">
                                        <div
                                            *ngIf="item?.payment?.status && item?.payment?.payments_similar && item?.payment?.payments_similar.length > 0">
                                            <div class="alert alert-warning mt-1"
                                                *ngFor="let ps of item?.payment?.payments_similar">
                                                <i class="fas fa-exclamation-triangle text-danger"></i> Existe otro pago
                                                con la misma referencia, cuenta depósito y monto.<br>Código de pago:
                                                <b>{{ ps.code }}</b>

                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-8">
                                        <div class="d-flex"
                                            [routerLink]="['/console/person/financial-payments/',item?.payment?.owner?.code]">

                                            <div>
                                                <div *ngIf="item?.owner?.file_selfie">
                                                    <img style="width: 32px; height: 32px;"
                                                        class="bd-placeholder-img flex-shrink-0 me-2 rounded "
                                                        [src]="sanitize(item?.payment?.owner?.file_selfie?.url)">
                                                </div>

                                                <div *ngIf="!item?.owner?.file_selfie">
                                                    <img *ngIf="item?.payment?.owner.gender != 'F'"
                                                        style="width: 32px; height: 32px;"
                                                        class="bd-placeholder-img flex-shrink-0 me-2 rounded "
                                                        [src]="sanitize('../assets/public/images/avatar.png')">
                                                    <img *ngIf="item?.payment?.owner.gender == 'F'"
                                                        style="width: 32px; height: 32px;"
                                                        class="bd-placeholder-img flex-shrink-0 me-2 rounded "
                                                        [src]="sanitize('../assets/public/images/avatara-female.png')">
                                                </div>
                                            </div>
                                            <div>
                                                <strong
                                                    class="text-gray-dark text-capitalize">{{item?.payment?.owner?.name}}
                                                    {{item?.payment?.owner?.lastName}}</strong>
                                            </div>
                                        </div>
                                    </div>





                                    <div class="col-4 mt-2  text-end">
                                        <div *ngIf="item?.payment?.file" [title]="item?.payment?.file?.url"
                                            class="text-primary fz-14" style="cursor:pointer">
                                            <span (click)="redirectIMG(item?.payment?.file, fileViewerModal)">Ver Adjunto</span>
                                        </div>
                                    </div>



                                    <div class="col-8   ">
                                        <div class="small text-secondary">Código</div>
                                        <div class=" text-dark small fw-bold"> {{item?.payment?.code}}</div>
                                    </div>

                                    <div class="col-4   ">

                                        <div class="text-end ms-auto">
                                            <div *ngIf="item?.payment?.typeTransaction !== 'DOMICILIATION'">
                                                <div class="small text-secondary">Conciliación</div>
                                                <div class=" small text-success fw-bold"
                                                    [ngClass]="{'text-success': item?.payment?.typeTransaction == 'AUTO','text-secondary': item?.payment?.typeTransaction != 'AUTO'}">
                                                    {{item?.payment?.typeTransaction == 'AUTO'?
                                                    item?.payment?.responseAutoConfirm?.source?findAutopago(item?.payment?.responseAutoConfirm?.source):'Auto':(item?.payment?.typeTransaction==='PENDING'?'Automática':'Manual')}}
                                                </div>
                                            </div>
                                            <div *ngIf="item?.payment?.typeTransaction === 'DOMICILIATION'">
                                                <div class="small text-secondary">Pago Domiciliado {{
                                                    item?.payment?.account_payment?.bank?.name }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="small text-secondary">Monto total</div>
                                        <div class=" text-dark fw-bold"> {{item?.payment?.amount | currency:'USD':'':
                                            '1.2-2'}} USD</div>
                                    </div>



                                    <div class="col-6 text-end ">
                                        <div class="small text-secondary">Estatus</div>

                                        <div class="text-success  fw-bold" *ngIf="item?.payment?.reconciled_payment">
                                            <div *ngIf="item?.payment?.payment_annulled">
                                                <span class="badge text-bg-primary"><i class="fas fa-undo me-1"></i>Devoluci&oacute;n</span>
                                            </div>
                                            <div
                                                *ngIf="!item?.payment?.payment_annulled && item?.payment?.typeTransaction!=='DOMICILIATION' && item?.payment?.status">
                                                <span class="badge text-bg-success">Aprobado</span>
                                            </div>
                                            <div *ngIf="!item?.payment?.payment_annulled && item?.payment?.typeTransaction==='DOMICILIATION'">
                                                <div *ngIf="item?.payment?.amount===0">
                                                    <span
                                                        class="badge text-bg-danger">{{item?.payment?.description}}</span>
                                                </div>
                                                <div *ngIf="item?.payment?.amount>0 && item?.payment?.status">
                                                    <span class="badge text-bg-success">Aprobado</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class=" fw-bold"
                                            *ngIf="!item?.payment?.reconciled_payment &&  item?.payment?.status">
                                            <span class="badge text-bg-warning"
                                                *ngIf="item?.payment?.typeTransaction!=='PENDING'">Por conciliar</span>
                                            <span class="badge text-bg-warning"
                                                *ngIf="item?.payment?.typeTransaction==='PENDING'">En proceso de
                                                validación</span>
                                        </div>

                                        <div class=" fw-bold" *ngIf="!item?.payment?.status">

                                            <div *ngIf="item?.payment?.typeTransaction!=='DOMICILIATION'">
                                                <span class="badge text-bg-danger">{{item?.payment?.typeTransaction ==
                                                    'AUTO'?'Transacción fallida': 'Anulado'}}</span>
                                            </div>
                                            <div *ngIf="item?.payment?.typeTransaction==='DOMICILIATION'">
                                                <span class="badge text-bg-danger">Rechazado por el Banco</span>
                                            </div>


                                        </div>

                                    </div>


                                    <div class="col-6 ">
                                        <div class="small text-secondary">Tasa de cambio a la fecha del pago</div>
                                        <div class=" fw-bold text-dark "> USD 1 = BS {{item?.payment?.rate |
                                            currency:'USD':'': '1.2-2'}}</div>
                                    </div>


                                    <div class="col-6 text-end">
                                        <div class="small text-secondary">Monto del pago </div>
                                        <div class=" fw-bold  text-dark"> {{item?.payment?.counterValue |
                                            currency:'USD':'': '1.2-2'}} {{item?.payment?.currency?.name}}</div>
                                    </div>



                                    <div class="col-6 ">

                                        <div class="small text-secondary">Fecha conciliación / Anulación</div>

                                        <div class=" fw-bold "
                                            *ngIf="item?.payment?.reconciled_payment_date || item?.payment?.reconciled_payment_ejecutive ">
                                            <div class=" text-dark"> {{item?.payment?.reconciled_payment_date | date:
                                                'dd/MM/yyyy h:mm:ss a'}}</div>

                                            <div class=" text-dark" *ngIf="!item?.payment?.reconciled_payment">
                                                {{item?.payment?.reconciled_payment_ejecutive | date: 'dd/MM/yyyy
                                                h:mm:ss a'}}</div>
                                        </div>
                                        <div
                                            *ngIf="!(item?.payment?.reconciled_payment || item?.payment?.reconciled_payment_ejecutive)">
                                            -
                                        </div>

                                    </div>

                                    <div class="col-6 text-end">
                                        <div class="small text-secondary ">Responsable </div>
                                        <div class=" fw-bold text-dark small text-capitalize">
                                            <div class=" text-dark  text-capitalize">
                                                {{item?.payment?.reconciled_payment_ejecutive?.name}}
                                                {{item?.payment?.reconciled_payment_ejecutive?.lastName}}</div>
                                            <div class=" text-dark  text-capitalize"
                                                *ngIf="!item?.payment?.reconciled_payment_ejecutive">-</div>

                                        </div>

                                    </div>

                                    <div class="col-6">

                                        <div class="small text-secondary">Tipo de producto</div>
                                        <div class=" fw-bold text-dark small text-capitalize">
                                            {{item?.payment?.params?.product_type?.type || item?.payment?.typeProduct ||
                                            'CREDIT'}}
                                        </div>

                                    </div>

                                    <div class="col-12  text-end">
                                        <div class="small text-secondary">Motivo de anulación </div>
                                        <div class=" text-dark fw-bold"> {{item?.payment?.description || '-'}}</div>
                                    </div>


                                    <div class="col-6">
                                        <div class="small text-secondary ">Fecha de reporte</div>
                                        <div class=" text-dark fw-bold"> {{item?.payment?.date | date: 'dd/MM/yyyy
                                            h:mm:ss a'}}</div>

                                    </div>


                                    <div class="col-6 text-end">

                                        <div class="small text-secondary ">Canal de reporte </div>
                                        <div class=" fw-bold text-dark small text-capitalize"
                                            *ngIf="item?.payment?.creator_api">{{item?.payment?.creator_api}}
                                            <ng-container
                                                *ngIf="item?.payment?.creator?.name || item?.payment?.creator?.lastName">
                                                / {{ item?.payment?.creator?.name }} {{ item?.payment?.creator?.lastName
                                                }}
                                            </ng-container>
                                        </div>
                                        <div class=" fw-bold text-dark small text-capitalize"
                                            *ngIf="!item?.payment?.creator_api">-</div>

                                    </div>



                                    <div class="col-6">

                                        <div class="small text-secondary">Fecha de pago</div>
                                        <div class=" text-dark fw-bold" *ngIf="item?.payment?.register_payment_date">
                                            {{item?.payment?.register_payment_date | date: 'dd/MM/yyyy'}}</div>
                                        <div class=" text-dark fw-bold" *ngIf="!item?.payment?.register_payment_date">
                                            {{item?.payment?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>


                                    </div>

                                    <div class="col-6  text-end">
                                        <div class="small text-secondary"> Responsable edición </div>
                                        <div class=" text-dark fw-bold" *ngIf="item?.payment?.payment_edit_ejecutive">
                                            {{item?.payment?.payment_edit_ejecutive?.name}}
                                            {{item?.payment?.payment_edit_ejecutive?.lastName}}</div>
                                        <div class=" fw-bold text-dark small text-capitalize"
                                            *ngIf="!item?.payment?.payment_edit_ejecutive">-</div>

                                    </div>



                                    <div class="col-6   ">
                                        <div class="small text-secondary">Banco origen </div>
                                        <div class=" text-dark fw-bold"> {{(item?.payment?.bankCode &&
                                            banks[item?.payment?.bankCode]) || '-'}}</div>
                                    </div>

                                    <div class="col-6  text-end">
                                        <div class="small text-secondary">Método de pago</div>
                                        <div class=" text-dark fw-bold">
                                            {{item?.payment?.account_payment?.payment_method?.name || ''}}</div>
                                    </div>


                                    <div class="col-12" *ngIf="item?.payment?.automatic_direct_debit?.error">
                                        <div class="small text-secondary">Motivo de Rechazo</div>
                                        <div class=" text-dark">
                                            {{item?.payment?.automatic_direct_debit?.error?.description }}
                                        </div>
                                    </div>


                                    <div class="col-6 mt-2">
                                        <div class="small text-secondary">Teléfono de origen</div>
                                        <div class=" text-dark fw-bold"> {{item?.payment?.phone ? item?.payment?.phone
                                            :'-'}}</div>
                                    </div>

                                    <div class="col-6  text-end ">
                                        <div class="small text-secondary">Número de referencia</div>
                                        <div class=" text-dark fw-bold"> {{item?.payment?.paymentMethodId || '-'}}</div>
                                    </div>


                                    <div class="col-6">
                                        <div class="small text-secondary">Cuenta origen (Últimos 6)</div>
                                        <div class=" text-dark  fw-bold"> {{item?.payment?.account || '-' }}</div>
                                    </div>

                                    <div class="col-6  text-end">

                                        <div class="small text-secondary">Cédula/Rif titular de la Cta.</div>
                                        <div class=" text-dark  fw-bold"> {{item?.payment?.cid != 'V' ?
                                            item?.payment?.cid :'-'}}</div>
                                    </div>


                                    <div class="col-12">
                                        <div class="small text-secondary">Banco destino</div>
                                        <div class=" text-dark  fw-bold"> {{item?.payment?.account_payment?.bank?.name
                                            || '-'}} </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="small text-secondary">Teléfono destino</div>
                                        <div class=" text-dark  fw-bold">{{item?.payment?.account_payment?.phone ||
                                            '-'}} </div>
                                    </div>

                                    <div class="col-6  text-end">
                                        <div class="small text-secondary">Cuenta destino</div>
                                        <div class=" text-dark  fw-bold">{{item?.payment?.account_payment?.number ||
                                            '-'}} </div>
                                    </div>


                                    <div class="col-6"
                                        *ngIf="item?.payment?.totalPaymentDue > 0 && item?.payment?.status">

                                        <div class="small text-secondary">Monto sin aplicar</div>
                                        <div class=" text-dark  fw-bold">{{item?.payment?.totalPaymentDue}} </div>

                                    </div>

                                </div>




                                <div class="fw-bold text-secondary mt-3 mb-2"
                                    *ngIf="item?.payment?.responseAutoConfirm?.voucher">Voucher</div>


                                <div class="text-dark  fw-bold fz-12 mb-2"
                                    *ngIf="item?.payment?.responseAutoConfirm?.descripcion">
                                    {{item?.payment?.responseAutoConfirm?.descripcion}}
                                </div>

                                <div class="row" *ngIf="item?.payment?.responseAutoConfirm?.voucher">
                                    <div class="col-12 col-md-6">
                                        <div class="voucher p-2 text-dark text-uppercase"
                                            [innerHTML]="item?.payment?.responseAutoConfirm?.voucher">

                                        </div>

                                    </div>
                                </div>

                                <div class="row mt-2" *ngIf="item?.payment?.payment_annulled || item?.payment?.special_flow_data">
                                    <div class="col-12 mt-1" *ngIf="item?.payment?.payment_annulled">
                                        <div class="small text-secondary">Motivo de anulaci&oacute;n: {{ item?.payment?.payment_annulled_description || item?.payment?.description }}</div>
                                    </div>

                                    <div class="col-12 mt-1" *ngIf="item?.payment?.special_flow_data">
                                        <div class="small text-secondary"><span *ngIf="item?.payment?.special_flow_data?.description">{{ item?.payment?.special_flow_data?.description }} - </span>Registrado por <span class="text-dark fw-bold">{{ item?.payment?.special_flow_data?.registered_by?.name }} {{ item?.payment?.special_flow_data?.registered_by?.lastName }}</span> el {{ item?.payment?.special_flow_data?.registered_at | date:'dd/MM/yyyy HH:mm' }}</div>
                                    </div>
                                </div>

                                <!-- 🤖 SECCIÓN DE VERIFICACIÓN ASÍNCRONA ACTUALIZADA -->
                                <div class="row mt-2 row-k" *ngIf="item.payment.async">
                                    <div class="col-6"></div>
                                    <div class="col-6 text-end">
                                        <div class="small text-secondary">
                                            <span class="badge"
                                                [class.text-bg-info]="item.payment.async.status==='PENDING'"
                                                [class.text-bg-warning]="item.payment.async.status==='RETRYING'"
                                                [class.text-bg-primary]="item.payment.async.status==='PROCESSING'"
                                                [class.text-bg-success]="item.payment.async.status==='COMPLETED'"
                                                [class.text-bg-danger]="item.payment.async.status==='FAILED'">
                                                <i class="fas fa-robot"></i>&nbsp;Verificación Asíncrona
                                            </span>

                                            <!-- 📊 Contador de intentos -->
                                            <small class="d-block mt-1">
                                                <strong>{{ item.payment.async.attempt || 0 }} de {{
                                                    item.payment.async.max_attempts || 0 }} intentos</strong>
                                            </small>

                                            <!-- ⏰ Último intento -->
                                            <small class="d-block" *ngIf="item.payment.async.last_attempt_at">
                                                <i class="fas fa-clock text-muted"></i> Último: {{
                                                formatAsyncDate(item.payment.async.last_attempt_at) }}
                                            </small>

                                            <!-- ⏭️ Próximo intento (solo si está RETRYING) -->
                                            <small class="d-block"
                                                *ngIf="item.payment.async.status === 'RETRYING' && item.payment.async.next_attempt_at">
                                                <i class="fas fa-forward text-primary"></i> Próximo: {{
                                                formatAsyncDate(item.payment.async.next_attempt_at) }}
                                            </small>

                                            <!-- 📋 Historial de intentos (clickeable) -->
                                            <small class="d-block mt-1"
                                                *ngIf="item.payment.async.attempt_history && item.payment.async.attempt_history.length > 0">
                                                <a href="javascript:void(0)" class="text-decoration-none text-primary"
                                                    (click)="openAsyncHistoryModal(item.payment)">
                                                    <i class="fas fa-history"></i> Ver historial ({{
                                                    item.payment.async.attempt_history.length }})
                                                </a>
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-3 row-k" *ngIf="item?.paymen_categ_concept_deduc?.length > 0">


                                    <div class="fw-bold text-secondary">Penalidad</div>

                                    <ng-container class="mt-2"
                                        *ngFor=" let row of item?.paymen_categ_concept_deduc ;let i = index">
                                        <ng-container class="mt-2" *ngIf="row?.fee">



                                            <div class="col-6">
                                                <div class="small ">
                                                    <span>
                                                        {{ row?.fee?.concept_deduction?.name }}

                                                    </span>

                                                </div>

                                                <div class="small text-secondary small">{{row?.fee?.code }}</div>

                                            </div>
                                            <div class="col-6  text-end ">
                                                <div class=" text-dark">
                                                    <ng-container>{{row?.amount | currency:'USD':'': '1.2-2'}}
                                                        USD</ng-container>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </ng-container>

                                </div>





                                <div class="row mt-3 row-k " *ngIf="item?.installMent?.length > 0">
                                    <div class="fw-bold text-secondary">Distribución</div>
                                    <ng-container class="mt-2" *ngFor=" let item2 of item?.installMent ;let i = index">


                                        <div class="col-6">
                                            <div class="small ">
                                                <span>
                                                    {{item2?.installMent?.invoice?.identifier}} /
                                                    {{ item2?.installMent?.order
                                                    < 1 ? 'Inicial' : 'Cuota ' + item2?.installMent?.order }} <div
                                                        class="small text-secondary small">{{item2?.installMent?.code }}
                                            </div>

                                            </span>

                                        </div>

                                        <div class="small text-secondary small">{{item?.payment?.installMent?.code }}
                                        </div>

                                </div>
                                <div class="col-6  text-end ">
                                    <div class=" text-dark"> {{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                </div>

                        </ng-container>

                    </div>

                    <!-- 🏥 SECCIÓN DE REPORTE DE SEGUROS -->
                    <div class="row mt-2 row-k" *ngIf="item.payment.params?.insurance_report || (item.payment.typeProduct && item.payment.typeProduct.startsWith('SEGURO'))">
                        <div class="col-6"></div>
                        <div class="col-6 text-end">
                            <div class="small text-secondary">
                                <span class="badge"
                                    [class.text-bg-success]="item.payment.params.insurance_report.reportado"
                                    [class.text-bg-warning]="!item.payment.params.insurance_report.reportado && item.payment.params.insurance_report.current_intento > 0 && !item.payment.params.insurance_report.permanently_failed"
                                    [class.text-bg-danger]="item.payment.params.insurance_report.permanently_failed"
                                    [class.text-bg-info]="!item.payment.params.insurance_report.reportado && item.payment.params.insurance_report.current_intento === 0">
                                    <i class="fas fa-file-medical-alt"></i>&nbsp;Reporte a Aseguradora
                                </span>

                                <!-- 📊 Contador de intentos -->
                                <small class="d-block mt-1">
                                    <strong>{{ item.payment.params.insurance_report.current_intento || 0 }} de {{
                                        item.payment.params.insurance_report.limite || 10 }} intentos</strong>
                                </small>

                                <!-- ✅ Fecha de reporte exitoso -->
                                <small class="d-block" *ngIf="item.payment.params.insurance_report.reportado && item.payment.params.insurance_report.reported_at">
                                    <i class="fas fa-check-circle text-success"></i> Reportado: {{
                                    formatAsyncDate(item.payment.params.insurance_report.reported_at) }}
                                </small>

                                <!-- ⏰ Último intento -->
                                <small class="d-block" *ngIf="!item.payment.params.insurance_report.reportado && item.payment.params.insurance_report.last_attempt_at">
                                    <i class="fas fa-clock text-muted"></i> Último: {{
                                    formatAsyncDate(item.payment.params.insurance_report.last_attempt_at) }}
                                </small>

                                <!-- ❌ Fallido permanentemente -->
                                <small class="d-block text-danger" *ngIf="item.payment.params.insurance_report.permanently_failed">
                                    <i class="fas fa-exclamation-triangle"></i> Límite de intentos excedido
                                </small>

                                <!-- 📋 Historial de intentos (clickeable) -->
                                <small class="d-block mt-1"
                                    *ngIf="item.payment.params?.insurance_report?.history && item.payment.params.insurance_report.history.length > 0">
                                    <a href="javascript:void(0)" class="text-decoration-none text-primary"
                                        (click)="openInsuranceReportHistoryModal(item.payment)">
                                        <i class="fas fa-history"></i> Ver historial ({{
                                        item.payment.params.insurance_report.history.length }})
                                    </a>
                                </small>

                                <!-- 🔄 Botón Reportar/Reintentar a Aseguradora -->
                                <div class="mt-2"
                                    *ngIf="!item.payment.params?.insurance_report?.reportado">
                                    <button
                                        class="btn btn-sm btn-outline-warning"
                                        [disabled]="item.payment._retryingInsurance"
                                        (click)="retryInsuranceReport(item)">
                                        <i class="fas" [ngClass]="item.payment._retryingInsurance ? 'fa-spinner fa-spin' : 'fa-redo'"></i>
                                        {{ item.payment._retryingInsurance ? 'Reportando...' :
                                           (item.payment.params?.insurance_report ? 'Reintentar Reporte' : 'Reportar a Seguro') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row row-k" *ngIf="item?.paymen_categ_concept_deduc?.length > 0">

                        <ng-container *ngFor=" let item3 of item?.paymen_categ_concept_deduc ;let i = index">
                            <div class="col-8"
                                *ngIf="item3?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                                <div class="small">{{item3?.category_concept_deduction?.concept_deduction?.name}}
                                    <span class="text-secondary"
                                        *ngIf="item3?.category_concept_deduction.isPorcent">{{item3?.category_concept_deduction?.amount}}%</span>
                                </div>
                            </div>
                            <div class="col-4 text-end "
                                *ngIf="item3?.category_concept_deduction?.concept_deduction?.name  == 'IGTF'">
                                <div class=" text-dark"> {{item3?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                            </div>

                        </ng-container>

                    </div>

                    <!-- <pre>{{ item?.payment | json }}</pre> -->
                    <div class="row mt-4">

                        <div class="col-12 col-md-8"
                            *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST','ACCOUNTING_ANALYST']) && !item?.payment?.reconciled_payment &&  item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'">
                            <div class="input-group">
                                <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.activate_review']) || !_auth.hasRbac$.getValue()"
                                    (click)="changeSubStatus(item?.payment?.code, subStatus[item?.payment?.code] == 'REVISION'? 'NA':'REVISION')"
                                    [ngClass]="{'btn-primary': subStatus[item?.payment?.code] == 'REVISION','btn-secondary':subStatus[item?.payment?.code]   != 'REVISION' }"
                                    class="btn btn-sm ">
                                    {{subStatus[item?.payment?.code] == 'REVISION'?'Inactivar revisión' : 'Activar
                                    revisión'}}
                                </button>
                            </div>
                        </div>

                        <div *ngIf="_auth.hasAccessOrProfile('finanzas', ['OWNER','ANALIST','ACCOUNTING_ANALYST']) && !item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'"
                            class="col-12 col-md-4 text-end">
                            <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.approve']) || !_auth.hasRbac$.getValue()" [disabled]="loadcon" type="button" (click)="concilidarPago(item?.payment)"
                                class="btn btn-primary mt-2 btn-sm">
                                Aprobar
                                <span *ngIf="loadcon">...</span> </button>
                            <button *ngIf="_auth.hasAnyPermission(['finanzas.verificacion_pagos.cancel']) || !_auth.hasRbac$.getValue()" [disabled]="loadcon2" type="button" (click)="cancelPayment(item?.payment?.code)"
                                class="btn btn-outline-danger  ms-2 mt-2 btn-sm">
                                Anular
                                <span *ngIf="loadcon2">...</span> </button>
                        </div>
                    </div>

                </div>
            </ng-container>


            <div *ngIf="!loading_person &&  resp_paymentsCredits?.length > 0" class="mt-4 text-center">

                <button type="button " class="btn btn-primary primary  " (click)="nextRows()">Siguientes + </button>

            </div>


            <!-- <pre>{{ resp_paymentsCredits | json }}</pre> -->


        </div>
    </div>


    </ng-container>


    <ng-container *ngIf="loading_person">
        <div class="w-100 text-center mt-2">
            <img src="./assets/public/images/loading.gif  " alt=" ">
        </div>
    </ng-container>

    <div *ngIf="!loading_person && resp_paymentsCredits?.length < 1 " class="col-12  col-md-10 offset-md-1">
        <div class="empty-state-container">
            <div class="empty-state-content">
                <div class="empty-state-icon">
                    <i class="fas fa-receipt"></i>
                </div>
                <h4 class="empty-state-title">No se encontraron pagos</h4>
                <p class="empty-state-description">
                    No hay pagos que coincidan con los filtros seleccionados.
                    <br>
                    Intenta ajustar los criterios de búsqueda o el rango de fechas.
                </p>
            </div>
        </div>
    </div>

</div>
</div>

</div>

<!-- 🤖 MODAL DE HISTORIAL DE VERIFICACIÓN ASÍNCRONA -->
<div class="modal fade" id="asyncHistoryModal" tabindex="-1" aria-labelledby="asyncHistoryModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="asyncHistoryModalLabel">
                    <i class="fas fa-robot me-2"></i>Historial de Verificación Asíncrona
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeAsyncHistoryModal()"></button>
            </div>
            <div class="modal-body">
                <!-- Payment Info Header -->
                <div class="card mb-3" *ngIf="selectedAsyncPayment">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <small class="text-muted">Código de Pago</small>
                                <div class="fw-bold">{{ selectedAsyncPayment.code }}</div>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted">Monto</small>
                                <div class="fw-bold">{{ selectedAsyncPayment.amount | currency:'USD':'':'1.2-2' }} USD
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <small class="text-muted">Estado Actual</small>
                                <div>
                                    <span class="badge"
                                        [class.text-bg-info]="selectedAsyncPayment.async?.status==='PENDING'"
                                        [class.text-bg-warning]="selectedAsyncPayment.async?.status==='RETRYING'"
                                        [class.text-bg-primary]="selectedAsyncPayment.async?.status==='PROCESSING'"
                                        [class.text-bg-success]="selectedAsyncPayment.async?.status==='COMPLETED'"
                                        [class.text-bg-danger]="selectedAsyncPayment.async?.status==='FAILED'"
                                        [class.text-bg-secondary]="!selectedAsyncPayment.async?.status">
                                        {{ selectedAsyncPayment.async?.status || 'Sin estado' }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted">Intentos</small>
                                <div class="fw-bold">{{ selectedAsyncPayment.async?.attempt || 0 }} de {{
                                    selectedAsyncPayment.async?.max_attempts || 0 }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- History Timeline -->
                <div class="timeline"
                    *ngIf="selectedAsyncPayment?.async?.attempt_history && selectedAsyncPayment.async.attempt_history.length > 0">
                    <div class="timeline-item"
                        *ngFor="let attempt of selectedAsyncPayment.async.attempt_history; let i = index">
                        <div class="timeline-marker" [class.bg-success]="attempt.status === 'COMPLETED'"
                            [class.bg-danger]="attempt.status === 'FAILED'"
                            [class.bg-primary]="attempt.status === 'PROCESSING'">
                            <i class="fas fa-circle text-white" style="font-size: 8px;"></i>
                        </div>
                        <div class="timeline-content">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <h6 class="card-title mb-0">
                                            <i class="fas fa-redo-alt me-1"></i>Intento #{{ (attempt.attempt || 0) + 1
                                            }}
                                        </h6>
                                        <span class="badge" [class.text-bg-success]="attempt.status === 'COMPLETED'"
                                            [class.text-bg-danger]="attempt.status === 'FAILED'"
                                            [class.text-bg-primary]="attempt.status === 'PROCESSING'">
                                            {{ attempt.status }}
                                        </span>
                                    </div>

                                    <div class="row text-sm">
                                        <div class="col-md-6">
                                            <small class="text-muted">Iniciado</small>
                                            <div>{{ attempt.started_at | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                                        </div>
                                        <div class="col-md-6" *ngIf="attempt.completed_at">
                                            <small class="text-muted">Completado</small>
                                            <div>{{ attempt.completed_at | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                                        </div>
                                    </div>

                                    <div class="row text-sm mt-2" *ngIf="attempt.response_time_ms">
                                        <div class="col-md-6">
                                            <small class="text-muted">Tiempo de Respuesta</small>
                                            <div>{{ attempt.response_time_ms }}ms</div>
                                        </div>
                                        <div class="col-md-6" *ngIf="attempt.verification_type">
                                            <small class="text-muted">Tipo de Verificación</small>
                                            <div>{{ attempt.verification_type }}</div>
                                        </div>
                                    </div>

                                    <div *ngIf="attempt.error_message" class="mt-2">
                                        <small class="text-muted">Error</small>
                                        <div class="text-danger small">{{ attempt.error_message }}</div>
                                    </div>

                                    <div *ngIf="attempt.response_data" class="mt-2">
                                        <small class="text-muted">Respuesta</small>
                                        <div class="small bg-light p-2 rounded">
                                            <pre class="mb-0">{{ attempt.response_data | json }}</pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- No History Message -->
                <div *ngIf="!selectedAsyncPayment?.async?.attempt_history || selectedAsyncPayment.async.attempt_history.length === 0"
                    class="text-center py-4">
                    <i class="fas fa-history fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">Sin historial disponible</h5>
                    <p class="text-muted">Este pago aún no tiene intentos de verificación registrados.</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="closeAsyncHistoryModal()">Cerrar</button>
            </div>
        </div>
    </div>
</div>

<!-- 🖼️ MODAL DE VISUALIZACIÓN DE IMÁGENES -->
<ng-template #fileViewerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-image me-2"></i>
      Imagen Adjunta
    </h5>
    <button type="button" class="btn-close" (click)="closeFileModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body text-center p-4" style="display: flex; align-items: center; justify-content: center; min-height: 400px;">
    <!-- Mostrar imagen -->
    <div *ngIf="selectedFileType === 'image'" class="image-container" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <img [src]="selectedFileUrl" 
           alt="Archivo adjunto" 
           class="img-fluid rounded shadow-sm"
           style="max-width: 100%; max-height: 70vh; object-fit: contain; display: block; margin: 0 auto;"
           (error)="selectedFileType = 'error'">
    </div>
    
    <!-- Error al cargar -->
    <div *ngIf="selectedFileType === 'error'" class="text-center">
      <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
      <h5 class="mt-3">No se pudo cargar la imagen</h5>
      <p class="text-muted">La imagen no se puede visualizar en el navegador.</p>
      <a [href]="selectedFileUrl" target="_blank" class="btn btn-primary mt-2">
        <i class="fas fa-external-link-alt me-1"></i>
        Abrir en nueva pestaña
      </a>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-primary" (click)="downloadCurrentFile()">
      <i class="fas fa-download me-1"></i>
      Descargar
    </button>
    <button type="button" class="btn btn-secondary" (click)="closeFileModal()">
      <i class="fas fa-times me-1"></i>
      Cerrar
    </button>
  </div>
</ng-template>

<!-- 🏥 MODAL DE HISTORIAL DE REPORTE DE SEGUROS -->
<div class="modal fade" id="insuranceReportHistoryModal" tabindex="-1" aria-labelledby="insuranceReportHistoryModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="insuranceReportHistoryModalLabel">
                    <i class="fas fa-file-medical-alt me-2"></i>Historial de Reporte a Aseguradora
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeInsuranceReportHistoryModal()"></button>
            </div>
            <div class="modal-body">
                <!-- Payment Info Header -->
                <div class="card mb-3" *ngIf="selectedInsuranceReportPayment">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <small class="text-muted">Código de Pago</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.code }}</div>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted">Monto</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.amount | currency:'USD':'':'1.2-2' }} USD
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <small class="text-muted">Estado Actual</small>
                                <div>
                                    <span class="badge"
                                        [class.text-bg-success]="selectedInsuranceReportPayment.params?.insurance_report?.reportado"
                                        [class.text-bg-warning]="!selectedInsuranceReportPayment.params?.insurance_report?.reportado && selectedInsuranceReportPayment.params?.insurance_report?.current_intento > 0 && !selectedInsuranceReportPayment.params?.insurance_report?.permanently_failed"
                                        [class.text-bg-danger]="selectedInsuranceReportPayment.params?.insurance_report?.permanently_failed"
                                        [class.text-bg-info]="!selectedInsuranceReportPayment.params?.insurance_report?.reportado && selectedInsuranceReportPayment.params?.insurance_report?.current_intento === 0">
                                        {{ selectedInsuranceReportPayment.params?.insurance_report?.reportado ? 'REPORTADO' : 
                                           selectedInsuranceReportPayment.params?.insurance_report?.permanently_failed ? 'FALLIDO' : 
                                           selectedInsuranceReportPayment.params?.insurance_report?.current_intento > 0 ? 'REINTENTANDO' : 'PENDIENTE' }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <small class="text-muted">Intentos</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.params?.insurance_report?.current_intento || 0 }} de {{
                                    selectedInsuranceReportPayment.params?.insurance_report?.limite || 10 }}</div>
                            </div>
                        </div>
                        <div class="row mt-2" *ngIf="selectedInsuranceReportPayment.params?.insurance_report?.policy_code">
                            <div class="col-md-12">
                                <small class="text-muted">Código de Póliza</small>
                                <div class="fw-bold">{{ selectedInsuranceReportPayment.params.insurance_report.policy_code }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- History Timeline -->
                <div class="timeline"
                    *ngIf="selectedInsuranceReportPayment?.params?.insurance_report?.history && selectedInsuranceReportPayment.params.insurance_report.history.length > 0">
                    <div class="timeline-item"
                        *ngFor="let attempt of selectedInsuranceReportPayment.params.insurance_report.history; let i = index">
                        <div class="timeline-marker" [class.bg-success]="attempt.success"
                            [class.bg-danger]="!attempt.success">
                            <i class="fas fa-circle text-white" style="font-size: 8px;"></i>
                        </div>
                        <div class="timeline-content">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <h6 class="card-title mb-0">
                                            <i class="fas fa-redo-alt me-1"></i>Intento #{{ attempt.attempt }}
                                        </h6>
                                        <span class="badge" [class.text-bg-success]="attempt.success"
                                            [class.text-bg-danger]="!attempt.success">
                                            {{ attempt.success ? 'EXITOSO' : 'FALLIDO' }}
                                        </span>
                                    </div>

                                    <div class="row text-sm">
                                        <div class="col-md-12">
                                            <small class="text-muted">Fecha y Hora</small>
                                            <div>{{ attempt.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</div>
                                        </div>
                                    </div>

                                    <div *ngIf="attempt.error" class="mt-2">
                                        <small class="text-muted">Error</small>
                                        <div class="text-danger small">{{ attempt.error }}</div>
                                    </div>

                                    <div *ngIf="attempt.error_details" class="mt-2">
                                        <small class="text-muted">Detalles del Error</small>
                                        <div class="small bg-light p-2 rounded">
                                            <pre class="mb-0">{{ attempt.error_details | json }}</pre>
                                        </div>
                                    </div>

                                    <div *ngIf="attempt.response" class="mt-2">
                                        <small class="text-muted">Respuesta de la Aseguradora</small>
                                        <div class="small bg-light p-2 rounded">
                                            <pre class="mb-0">{{ attempt.response | json }}</pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- No History Message -->
                <div *ngIf="!selectedInsuranceReportPayment?.params?.insurance_report?.history || selectedInsuranceReportPayment.params.insurance_report.history.length === 0"
                    class="text-center py-4">
                    <i class="fas fa-history fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">Sin historial disponible</h5>
                    <p class="text-muted">Este pago aún no tiene intentos de reporte registrados.</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="closeInsuranceReportHistoryModal()">Cerrar</button>
            </div>
        </div>
    </div>
</div>
<!-- 🖼️ MODAL DE VISUALIZACIÓN DE IMÁGENES -->
<ng-template #fileViewerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-image me-2"></i>
      Imagen Adjunta
    </h5>
    <button type="button" class="btn-close" (click)="closeFileModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body text-center p-4" style="display: flex; align-items: center; justify-content: center; min-height: 400px;">
    <!-- Mostrar imagen -->
    <div *ngIf="selectedFileType === 'image'" class="image-container" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <img [src]="selectedFileUrl" 
           alt="Archivo adjunto" 
           class="img-fluid rounded shadow-sm"
           style="max-width: 100%; max-height: 70vh; object-fit: contain; display: block; margin: 0 auto;"
           (error)="selectedFileType = 'error'">
    </div>
    
    <!-- Error al cargar -->
    <div *ngIf="selectedFileType === 'error'" class="text-center">
      <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
      <h5 class="mt-3">No se pudo cargar la imagen</h5>
      <p class="text-muted">La imagen no se puede visualizar en el navegador.</p>
      <a [href]="selectedFileUrl" target="_blank" class="btn btn-primary mt-2">
        <i class="fas fa-external-link-alt me-1"></i>
        Abrir en nueva pestaña
      </a>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-primary" (click)="downloadCurrentFile()">
      <i class="fas fa-download me-1"></i>
      Descargar
    </button>
    <button type="button" class="btn btn-secondary" (click)="closeFileModal()">
      <i class="fas fa-times me-1"></i>
      Cerrar
    </button>
  </div>
</ng-template>
